export const TransactionStatusEnum = {
  EM_PROCESSAMENTO: 'EM_PROCESSAMENTO',
  PAGAMENTO_PENDENTE: 'PAGAMENTO_PENDENTE'
}

export class CompleteTransactionResponseDTO {
  constructor (protocolo, transacao, msisdn, codigoPix, idPedidoVenda, status, idExterno, expiracaoPix) {
    this.protocolo = protocolo
    this.transacao = transacao
    this.msisdn = msisdn
    this.codigoPix = codigoPix
    this.idPedidoVenda = idPedidoVenda
    if (TransactionStatusEnum[status] === undefined) throw new Error('Invalid status')
    this.status = status
    this.idExterno = idExterno
    this.expiracaoPix = expiracaoPix
  }
}
